import { createContext, memo, useCallback, useContext, useState } from "react";
import { ILocale, localeKeys } from "./conf";
import { Locales, i18n } from "@commons/locales";
import { Box } from "@mui/material";
import * as types from "./types";
import * as styles from "./styles";

const initialLocale: ILocale =
  Locales.find((L) => L.key === i18n.language) || Locales[0];

const Context = createContext<any>(null);

const Provider = memo((props: types.IProps) => {
  const [state, setState] = useState<types.IState>(initialLocale);

  const updateLocale = useCallback((key: localeKeys) => {
    const locale = Locales.find((L) => L.key === key);
    if (locale) {
      setState(locale);
      i18n.changeLanguage(locale.key);
    }
  }, []);

  const values: types.IContext = {
    ...state,
    updateLocale,
  };

  return (
    <Context.Provider value={values}>
      <Box dir={state.direction} sx={styles.localeContainer}>
        {props.children}
      </Box>
    </Context.Provider>
  );
});

export default Provider;

export const useLocaleContext = (): types.IContext => useContext(Context);
